import {
  Grid,
  Stack,
  Tooltip,
  IconButton,
  Switch,
  Fab,
  Typography as TypographyMUI,
} from '@mui/material';
import { TextField } from 'mui-rff';
import { Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';

import { Add as AddIcon, Close as CloseIcon } from '@mui/icons-material';
import MultiSelect from '@components/MultiSelect';

import {
  DYNAMIC_RULE_TYPE_LIST,
  DYNAMIC_RULE_OPERATOR_LIST,
} from '../../../../payment-orchestration.constants';
import { createEmptyDynamicRuleCondition } from '../../../../payment-orchestration.utils';

export default function ConditionsForm({ push, validators }) {
  const getAllowedOperator = (type) => DYNAMIC_RULE_OPERATOR_LIST[type];

  return (
    <Stack>
      <Stack
        flexDirection="row"
        alignItems="center"
        gap={2}
        mb={3}>
        <Tooltip
          title="Add a new Condition"
          placement="left">
          <Fab
            color="primary"
            size="small"
            sx={{ boxShadow: 'none' }}
            onClick={() =>
              push('conditions', createEmptyDynamicRuleCondition())
            }>
            <AddIcon />
          </Fab>
        </Tooltip>
        <TypographyMUI variant="formHeader">Conditions</TypographyMUI>
      </Stack>

      <FieldArray name="conditions">
        {({ fields }) =>
          fields.map((conditionRow, index) => (
            <Grid
              container
              spacing={2}
              paddingBottom={4}
              alignItems="center"
              key={conditionRow}>
              <Grid
                item
                xs={2}>
                <Field
                  name={`${conditionRow}.type`}
                  validate={validators.required}>
                  {({ input: { name, value } }) => (
                    <MultiSelect
                      {...{ name, value }}
                      required
                      onChange={({ value: newValue }) => {
                        fields.update(index, {
                          ...fields.value[index],
                          type: newValue,
                          operator: '',
                        });
                      }}
                      label="Select Type"
                      items={DYNAMIC_RULE_TYPE_LIST}
                      multiple={false}
                      optionDisplayKey="label"
                      optionValueKey="value"
                    />
                  )}
                </Field>
              </Grid>
              <Grid
                item
                xs={2}>
                <Field
                  name={`${conditionRow}.parameterName`}
                  validate={validators.required}>
                  {({ input: { name, value, onChange } }) => (
                    <TextField
                      {...{ name, value, onChange }}
                      required
                      label="Name"
                      type="text"
                    />
                  )}
                </Field>
              </Grid>
              <Grid
                item
                xs={3}>
                <Field
                  name={`${conditionRow}.operator`}
                  validate={validators.required}>
                  {({ input: { name, value, onChange } }) => (
                    <MultiSelect
                      {...{ name, value }}
                      required
                      onChange={({ value: newValue }) => onChange(newValue)}
                      label="Select Operator"
                      items={getAllowedOperator(fields.value[index].type)}
                      multiple={false}
                      optionDisplayKey="label"
                      optionValueKey="value"
                      customOptionLabel={({ label, value: optionValue }) =>
                        `${label} (${optionValue})`
                      }
                    />
                  )}
                </Field>
              </Grid>
              <Grid
                item
                xs={2}>
                <Field
                  name={`${conditionRow}.parameterValue`}
                  validate={validators.required}>
                  {({ input: { name, value, onChange } }) => (
                    <TextField
                      {...{ name, value, onChange }}
                      required
                      label="Value"
                      type="text"
                    />
                  )}
                </Field>
              </Grid>
              <Grid
                item
                xs={2}>
                <Field name={`${conditionRow}.optional`}>
                  {({ input: { name, value, onChange } }) => (
                    <Stack
                      flexDirection="row"
                      alignItems="center">
                      <Switch
                        {...{ name, onChange }}
                        checked={value}
                      />
                      <TypographyMUI>Optional</TypographyMUI>
                    </Stack>
                  )}
                </Field>
              </Grid>
              <Grid
                item
                xs={1}>
                <IconButton
                  color="primary"
                  onClick={() => fields.remove(index)}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          ))
        }
      </FieldArray>
    </Stack>
  );
}
